import { Link } from "@inertiajs/react";
import { BookSerializersBookByline } from "types/serializers";

export interface Props {
  book: BookSerializersBookByline;
  className?: string;
}

export default function BookContributors({ book, className }: Props) {
  if (book.contributions && book.contributions.length > 0) {
    return (
      <ul className="list-comma">
        {book.contributions.map((contribution) => (
          <li
            key={`book-${book.id}-contribution-${contribution.author?.id}-${contribution.author?.name}-${contribution.contribution}`}
          >
            <Link
              href={`/authors/${contribution.author.slug}`}
              className={className}
            >
              {contribution.author.name}
            </Link>
          </li>
        ))}
      </ul>
    );
  }
  return <></>;
}
